import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "user-container"
};
const _hoisted_2 = {
  class: "owner-container"
};
const _hoisted_3 = {
  key: 1,
  class: "user-container"
};
const _hoisted_4 = {
  key: 2,
  class: "operation-bar"
};
const _hoisted_5 = {
  key: 3,
  class: "operation-bar"
};
const _hoisted_6 = {
  key: 4,
  class: "operation-bar"
};
import { ElButton, ElImage } from 'element-plus';
import { CaretRight } from '@element-plus/icons-vue'; // import { request } from '@/manager/net_manager'

export default {
  __name: 'ApplicationReviewCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    performanceStatus: {
      type: Number,
      required: true
    }
  },
  emits: ['addRole', 'update'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // functions

    const getApplicationTitle = () => {
      if (props.data.position === 0) {
        return '演职员申请';
      } else if (props.data.position === 1) {
        return '观众席申请';
      }

      return '异常申请';
    };

    const clickRole = roleId => {
      // console.log('clickRole', roleId)
      emits('addRole', roleId);
    };

    const cancelApplication = () => {
      if (!props.data) return;
      emits('update', props.data.id, 1);
    };

    const acceptApplication = () => {
      if (!props.data) return;
      emits('update', props.data.id, 2);
    };

    const deleteApplication = () => {
      if (!props.data) return;
      emits('update', props.data.id, 1);
    };

    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["card-container", __props.isSelected ? 'selected-card-container' : ''])
      }, [_createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(getApplicationTitle()), 1)]), _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), __props.data.position === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElImage), {
        src: __props.data.role.owner.avatar,
        fit: "cover",
        draggable: "false"
      }, null, 8, ["src"]), _createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(__props.data.role.owner.nickname), 1)])]), _cache[1] || (_cache[1] = _createElementVNode("text", {
        class: "desc"
      }, " 向当前舞台提交了角色 ", -1)), _createElementVNode("div", {
        class: "role-container",
        onClick: _cache[0] || (_cache[0] = $event => clickRole(__props.data.role.id))
      }, [_createVNode(_unref(ElImage), {
        src: __props.data.role.avatar,
        fit: "cover",
        draggable: "false"
      }, null, 8, ["src"]), _createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(__props.data.role.nickname) + " ", 1)]), _createVNode(_component_el_icon, {
        size: 18
      }, {
        default: _withCtx(() => [_createVNode(_unref(CaretRight))]),
        _: 1
      })])])) : __props.data.position === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(ElImage), {
        src: __props.data.role.owner.avatar,
        fit: "cover",
        draggable: "false"
      }, null, 8, ["src"]), _createElementVNode("text", null, [_createElementVNode("b", null, _toDisplayString(__props.data.role.owner.nickname), 1)]), _cache[2] || (_cache[2] = _createElementVNode("text", null, "  申请一个观众席位", -1))])) : _createCommentVNode("", true), __props.data.status === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(ElButton), {
        class: "refuse",
        onClick: cancelApplication
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" 拒绝申请 ", -1)]))]),
        _: 1
      }), _createVNode(_unref(ElButton), {
        onClick: acceptApplication
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" 接受申请 ", -1)]))]),
        _: 1
      })])) : __props.data.status === 2 && [0, 1].includes(__props.performanceStatus) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_unref(ElButton), {
        class: "refuse",
        onClick: deleteApplication
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 移除许可 ", -1)]))]),
        _: 1
      })])) : __props.data.status === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(ElButton), {
        class: "disabled",
        disabled: true
      }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 已拒绝 ", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true)], 2);
    };
  }

};